import { Formik } from "formik";
import React, { useState } from "react";
import Button from "_shared/components/Button/Button";
import InputField from "../../_shared/components/InputField/InputField";
import Loading from "../../_shared/components/Loading/Loading";
import { useModal } from "../../_shared/contexts/ModalContext";
import "./LoginWith42Macro.scss";
import { API } from "aws-amplify";
import { useHistory } from "react-router-dom";

const initialValues = { username: "", password: "", rememberMe: true };

export const LoginWith42Macro: React.FC<Props> = ({
  setVerified = null,
  userId = null,
}) => {
  const { onErrorMsg, onSuccessMsg } = useModal();
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const verify42MacroAccess = async (username, password) => {
    console.log(username, password);
    setLoading(true);
    try {
      const response = await API.post("public", "/cognito/42macroCheck", {
        body: { username, password, userId },
      });
      setLoading(false);
      if (response.Code === "success") {
        return onSuccessMsg(response.Message, () => {
          if (setVerified) {
            setVerified(true);
          } else {
            history.push("/signup", {
              verified42Macro: username.toLowerCase(),
            });
          }
        });
      } else {
        return onErrorMsg(response.Message);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
      return onErrorMsg("Your credentials are incorrect.");
    }
  };

  return (
    <div id="login-page">
      <div className="card">
        <div>
          <h2 className="welcome-back-text">
            Log into your{" "}
            <img
              style={{
                height: 40,
                width: 40,
                marginTop: -3,
                marginLeft: 5,
                marginRight: 3,
              }}
              src={"/42macro_tabs.svg"}
            />{" "}
            Macro account
          </h2>
          <div
            style={{
              width: 350,
              fontSize: 14,
              marginBottom: 20,
              marginTop: -30,
            }}
          >
            If you are subscribed to the{" "}
            <span style={{ fontWeight: 800, color: "#458bff" }}>
              42 Macro Bundle
            </span>{" "}
            or{" "}
            <span style={{ fontWeight: 800, color: "#458bff" }}>
              Around the Horn Weekly
            </span>
            , you are entitled to a complimentary{" "}
            <span style={{ fontWeight: 800, color: "#75ce41" }}>
              Longbow Plus
            </span>{" "}
            subscription. Log in using your 42 Macro credentials to claim
            access.
          </div>
          <Formik
            // TODO: validation is handled in submit because of the current error modal system
            onSubmit={async (values) => {
              if (!values.username) {
                return onErrorMsg("You must enter an email.");
              } else if (!values.password) {
                return onErrorMsg("You must enter a password.");
              }
              verify42MacroAccess(values.username, values.password);
            }}
            enableReinitialize
            initialValues={initialValues}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit} style={{ width: 355 }}>
                <div className="input-container">
                  <InputField name="username" label="42 Macro Email" />
                </div>
                <div className="input-container">
                  <InputField
                    type="password"
                    name="password"
                    label="42 Macro Password"
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    margin: "7px 0px",
                  }}
                ></div>
                <Button data-testid="button-login" type="submit" fullWidth>
                  Claim Longbow Plus access
                </Button>
              </form>
            )}
          </Formik>
          <div className="dont-have-account-text">
            <div className="justify-center">
              Can't remember your 42 Macro password?
            </div>
            <a
              target="_blank"
              href="https://app.42macro.com/reset"
              className="signup-link justify-center"
            >
              SEND A RESET PASSWORD LINK
            </a>
          </div>
        </div>
      </div>
      {loading && <Loading message="Verifying access..." />}
    </div>
  );
};

export default LoginWith42Macro;
